"use strict";

module.exports = class {
    grecaptcha;
    config;
    tokenRefreshed;
    tokenExpiry;
    intervalDuration;

    constructor(args) {
        if (typeof args === 'undefined' || typeof args.grecaptcha === 'undefined' || typeof args.config === 'undefined') {
            return null;
        }

        this.grecaptcha = args.grecaptcha;
        this.config = args.config;
        this.tokenRefreshed = Date.now();
        this.tokenExpiry = args.tokenExpiry ?? 120000;
        this.intervalDuration = this.tokenExpiry * 0.8;

        this.pageView();
        this.keepAlive();

        this.bind();
    }

    bind() {
        document.addEventListener('gform-recaptcha:doAction', (event) => { return this.onDoAction(event); });
    }

    doAction(action) {
        if (!action) {
            return null;
        }

        this.grecaptcha.ready(() => {
            this.grecaptcha.execute(this.config.site_key, { action: action }).then((token) => {
                this.tokenRefreshed = Date.now();
            });
        });
    }

    pageView() {
        this.doAction('page_view');
    }

    keepAlive() {
        setInterval(() => {
            if (Date.now() - this.tokenRefreshed > this.tokenExpiry) {
                return null;
            }

            this.doAction('keep_alive');
        }, this.intervalDuration);
    }

    onDoAction(event) {
        if (!(event instanceof Object)) {
            return null;
        }
        
        const action = event.detail.action ?? 'default_action';
        this.doAction(action);
    }
}